import Vue from "vue";

const qr_code_reader_mixins = {       
    data: () => ({
     
    }),
    methods: {
     MIX_decodeResult(result) {
        this.$store.dispatch("qr_code_reader_store/ACT_result", result);
        //this.result = result;
        var path = require("./assets/swapp_signin.mp3");
        var audio = new Audio(path); // path to file
        audio.play();
        //scroll issue
        window.scrollTo(0, 0);
     },
     MIX_setQrCode(result){
      var payloadD = {};
      payloadD.result = result;
      //console.log("THe decion in mixins " + payloadD.answer);
      this.$store.dispatch("qr_code_reader_store/ACT_result", result);
    },
     MIX_onInitError(error){
        console.error("QR camera init failed:", error.name, error.message, error); // aids remote diagnosis
        if (error.name === "NotAllowedError") {
            this.$store.dispatch("qr_code_reader_store/ACT_error", "Camera access was blocked. Please allow camera access in your browser settings, then reload this page.");
          } else if (error.name === "NotFoundError") {
            this.$store.dispatch("qr_code_reader_store/ACT_error", "No camera was found on this device.");
          } else if (error.name === "NotSupportedError") {
            this.$store.dispatch("qr_code_reader_store/ACT_error", "The camera needs a secure connection (HTTPS). Please check the address bar shows https://");
          } else if (error.name === "NotReadableError") {
            this.$store.dispatch("qr_code_reader_store/ACT_error", "The camera is already in use by another app. Please close other apps using the camera, then reload this page.");
          } else if (error.name === "OverconstrainedError") {
            this.$store.dispatch("qr_code_reader_store/ACT_error", "No suitable camera could be used on this device.");
          } else if (error.name === "StreamApiNotSupportedError") {
            this.$store.dispatch("qr_code_reader_store/ACT_error", "This browser does not support camera scanning. Please try a different browser, or SWAPP in manually.");
          } else if (error.name === "InsecureContextError") {
            this.$store.dispatch("qr_code_reader_store/ACT_error", "The camera needs a secure connection (HTTPS). Please check the address bar shows https://");
          } else {
            // never leave the user with a blank scanner and no explanation
            this.$store.dispatch("qr_code_reader_store/ACT_error", "The camera could not be started (" + (error.name || "unknown error") + "). Please reload the page, or SWAPP in manually.");
          }
     }
    }
  }
  
  export default {
    install (Vue, options) {
      Vue.mixin(qr_code_reader_mixins)
    }
  };
  
   
  